import React, { PropTypes } from "react";
import { Field } from "redux-form";
import { FormattedMessage } from "react-intl";

import { SelectInput } from "../../../../../../common/form";

import COVERAGE_CERTIFICATE_TYPES from "./../../enums/coverageCertificateTypes";
import BillingPeriodField from "../BillingPeriodField";

class CoverageCertificateForm extends React.Component {
  render() {
    const { billingPeriods } = this.props;
    return (
      <div>
        <BillingPeriodField
          id="billingPeriodId"
          name="billingPeriodId"
          billingPeriods={billingPeriods}
        />
        <Field
          id="coverageCertificateType"
          name="coverageCertificateType"
          component={SelectInput}
          sortOptions={false}
          options={COVERAGE_CERTIFICATE_TYPES}
          addBlankOption={true}
          label={
            <FormattedMessage id="clients.client.reports.coverageCertificate.form.formatType" />
          }
        />
      </div>
    );
  }
}

CoverageCertificateForm.propTypes = {
  billingPeriods: PropTypes.array.isRequired,
};

export default CoverageCertificateForm;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/reports/forms/coverageCertificate/coverageCertificateForm.js